import { keyframes } from 'styled-components';

export const rainbowTextRevealAnimation = keyframes`
    0% {
      background: linear-gradient(
        70deg,
        #000000 29%,
        rgba(243, 202, 77, 0.4) 37%,
        rgba(255, 152, 154, 0.4) 38%,
        rgba(203, 171, 255, 0.4) 39%,
        rgba(233, 220, 255, 0.4) 40%,
        #ffffff 41%,
        #ffffff 75%
      );
      background-clip: text;
      -webkit-background-clip: text;
      background-size: 400% 100%;
      color: transparent;
      background-position: 70%;
    }

    99% {
      background: linear-gradient(
        70deg,
        #000000 29%,
        rgba(243, 202, 77, 0.4) 37%,
        rgba(255, 152, 154, 0.4) 38%,
        rgba(203, 171, 255, 0.4) 39%,
        rgba(233, 220, 255, 0.4) 40%,
        #ffffff 41%,
        #ffffff 75%
      );
      background-clip: text;
      -webkit-background-clip: text;
      background-size: 400% 100%;
      color: transparent;
      background-position: 1%;
    }

    // we need to remove the background-clip before the end of the animation so the text editing looks correct, and we don't leave any emojis in goth mode.
    100% {
      background-position: 0%;
    }
`;

export const revealLeftToRight = keyframes`
    0% {
        mask-image: linear-gradient(230deg, #0000 25%, #000 75%);
        mask-size: 500%;
        mask-position: 100%;
    }

    100% {
        mask-image: linear-gradient(230deg, #0000 25%, #000 75%);
        mask-size: 500%;
        mask-position: 0%;
    }
`;

export const revealLeftToRightAlternate = keyframes`
    0% {
        mask-image: linear-gradient(230deg, #0000 20%, #000 55%);
        mask-size: 500%;
        mask-position: 100%;
    }

    100% {
        mask-image: linear-gradient(230deg, #0000 20%, #000 55%);
        mask-size: 500%;
        mask-position: 0%;
    }
`;
